import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { wsGetAll } from "services/WService";
import Modal from "components/Tvendo/Common/ModalBase";

export default function ModalSubFamily(props) {
  const subFamily = props.model;

  const [dataChanging, setDataChanging] = useState(subFamily);

  const [families, setFamilies] = useState([]); //familias

  async function listFamilies() {
    let response = await wsGetAll("logi/family");
    if (response.success) setFamilies(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  useEffect(() => {
    listFamilies();
  }, []);

  return (
    <Modal
      title="SubFamilias"
      model={subFamily}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="logi/sub-family"
      state
    >
      <TextField
        label="Código"
        type="text"
        name="code"
        margin="normal"
        fullWidth
        defaultValue={!!subFamily ? subFamily.code : ""}
        required
      />
      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={!!subFamily ? subFamily.description : ""}
        required
      />
      <Autocomplete
        options={families}
        getOptionLabel={(option) => option.description}
        defaultValue={
          !!subFamily
            ? families.find((family) => family.id == subFamily.logi_family_id)
            : undefined
        }
        renderInput={(params) => (
          <TextField {...params} label="Familia" margin="normal" required />
        )}
        onChange={(e, item) => {
          if (!!item) {
            return handleChange("logi_family_id", item.id);
          }
          handleChange("logi_family_id", null);
        }}
      />
    </Modal>
  );
}
